module.exports = __webpack_public_path__ + "img/招人-缩小.4173d5c1.png";